import { useQuery } from '@tanstack/react-query';
import type { AgentApiAllianceAgentsMetadata } from '@/types/serializers';

export const ALLIANCE_AGENTS_METADATA_QUERY_KEY = ['alliance_agents_metadata'] as const;

export default function useFetchAllianceAgentsMetadata() {
  return useQuery({
    queryKey: ALLIANCE_AGENTS_METADATA_QUERY_KEY,
    queryFn: async () => {
      const response = await fetch('/agent/api/alliance_agents/metadata');
      if (!response.ok) {
        throw new Error('エージェント上限情報の取得に失敗しました');
      }
      const data: AgentApiAllianceAgentsMetadata = await response.json();
      return data;
    },
  });
}
